import {
	endpointsMap,
	ICreateNotifyMeOptions,
	ICreateNotifyMeResponse
} from './ICustomShopperNotifyMe';

import AbstractCustomShopperAPI from '../AbstractCustomShopperAPI';
import {ICustomApiConfig} from '../ICustomApiConfig';

/**
 * Represents CustomShopperNotifyMe
 */
class CustomShopperNotifyMe extends AbstractCustomShopperAPI {
	/**
	 * @constructor
	 * @param {ICustomApiConfig} config - API Config
	 */
	constructor(config: ICustomApiConfig) {
		super(config);
	}

	/**
	 * Sets the custom context for the current customer
	 * @param {ICreateNotifyMeOptions} fetchOptions - options to pass to API Call
	 * @param {boolean} throwOnError - throw error if api returns error
	 *
	 * @returns {ICreateNotifyMeResponse} - Status of notify me request
	 */
	public async createNotifyMe(fetchOptions: ICreateNotifyMeOptions, throwOnError?: boolean): Promise<ICreateNotifyMeResponse> {
		const response: ICreateNotifyMeResponse = await this.callCustomEndpoint<ICreateNotifyMeResponse>(
			fetchOptions,
			endpointsMap.SUBSCRIBE
		);

		if (throwOnError && response.message !== 'NOTIFY_ME_CREATED') {
			throw new Error('Notify Me create error.');
		}

		return response;
	}
}

export default CustomShopperNotifyMe;
